export default {
  week: 604800000,
  day: 86400000,
  hour: 3600000,
  minute: 60000
}
